
// Web3Modal Project ID for WalletConnect
export const PROJECT_ID = 'a079b67c88f6891f45b0e3db1231fcfd';

// BSC Network Configuration
export const BSC_NETWORK = {
  chainId: 56,
  name: 'BNB Smart Chain',
  currency: 'BNB',
  explorerUrl: 'https://bscscan.com',
  rpcUrl: 'https://bsc-dataseed.binance.org',
};

// Solana Network Configuration  
export const SOLANA_NETWORK = {
  name: 'Solana Mainnet',
  rpcUrl: 'https://api.mainnet-beta.solana.com',
};
